import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { Row } from 'antd';
import { BaseBreadcrumbWithRender } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import { useHeader } from '@app/components/header/layouts/HeaderContext';
import FollowUpForm from '@app/components/apps/FollowUp/FollowUpForm'; // Updated to FollowUpForm

export const EditFollowUp: React.FC = () => {
  const location = useLocation();
  const { id, import_id } = location.state || {};
  const { t } = useTranslation();
  const [currentBreadcrumName, setCurrentBreadcrumName] = useState<string>('Edit Follow-Up');
  // console.log('EditFollowUp received:', { id, import_id });

  const { setBreadcrumb, clearHeaderButtons } = useHeader();

  const routes = [
    {
      path: '/follow-ups',
      breadcrumbName: 'Follow-Ups',
    },
    {
      path: '/edit-follow-up',
      breadcrumbName: currentBreadcrumName,
    },
  ];

  useEffect(() => {
    setBreadcrumb(<BaseBreadcrumbWithRender routes={routes} separator=">" />);

    return () => {
      setBreadcrumb(currentBreadcrumName);
      clearHeaderButtons();
    };
  }, [setBreadcrumb, clearHeaderButtons, currentBreadcrumName]);

  return (
    <>
      <Row gutter={[16, 16]}>
        <FollowUpForm
          type="edit"
          editable={true}
          id={id}
          import_id={import_id}
          pageTitle={`Edit Follow-Up`}
          setCurrentBreadcrumName={setCurrentBreadcrumName}
        />
      </Row>
    </>
  );
};

export default EditFollowUp;
